import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

const useSingleFileUpload = () => {
	const [base64Str, setBase64Str] = useState(null);

	const readFile = useCallback((file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				if (reader.result) {
					const base64String = reader.result;
					setBase64Str(base64String);
					resolve(base64String);
				} else {
					reject(new Error('File reading failed'));
				}
			};
			reader.onerror = (error) => {
				toast.error('Error reading file');
				reject(error);
			};
		});
	}, []);

	return { base64Str, readFile };
};

export default useSingleFileUpload;
